import React, { useState } from 'react';
import EmailIcon from '../assets/images/email.png';
import TimeIcon from '../assets/images/clock.png';
import axios from 'axios';

// API base URL configuration: uses full URL in production, empty for local proxy
const API_BASE = process.env.NODE_ENV === 'production' ? 'https://shuchiai.com' : '';


const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    comments: ''
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ text: '', type: '' });

    try {
      const response = await axios.post(API_BASE + '/lulto_admin/contact/addContact', formData);

      if (response.data.success) {
        setMessage({
          // text: 'Thank you! Your message has been sent successfully.',
          type: 'success'
        });

        // Reset form
        setFormData({
          name: '',
          email: '',
          phone: '',
          comments: ''
        });
      }
    } catch (error) {
      setMessage({
        text: error.response?.data?.message || 'Something went wrong. Please try again.',
        type: 'error'
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        {/* Left Column - Information Section */}
        <div className="contact-left">
          <h1 className="contact-main-heading">Let's Build Something Great</h1>
          <p className="contact-description">
            We create powerful mobile apps for iOS and Android that users love. From concept to launch, our expert team handles design, development, and deployment. Explore our portfolio and contact us to discuss your next project.
          </p>

          <h2 className="contact-subheading">Our Contact:</h2>
          <div className="contact-details">
            <div className="contact-detail-item">
              <span className="contact-icon"><img src={EmailIcon} alt="Email" /></span>
              <span className="contact-text">support@lutlo.com</span>
            </div>
            <div className="contact-detail-item">
              <span className="contact-icon"><img src={TimeIcon} alt="Time" /></span>
              <span className="contact-text">Mon-Sat 10:00 AM To 6:00 PM</span>
            </div>
          </div>
        </div>

        {/* Right Column - Contact Form */}
        <div className="contact-right">
          <div className="contact-form-card">
            <h2 className="form-title">Contact Us</h2>
            <p className="form-instruction">Please Fill out your information here</p>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Name"
                  className="form-input"
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email Address"
                  className="form-input"
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Phone Number"
                  className="form-input"
                  required
                />
              </div>
              <div className="form-group">
                <textarea
                  name="comments"
                  value={formData.comments}
                  onChange={handleChange}
                  placeholder="Comments"
                  className="form-textarea"
                  rows="4"
                  required
                ></textarea>
              </div>
              {message.text && (
                <div className={`form-message ${message.type}`}>
                  {message.text}
                </div>
              )}


              <button
                type="submit"
                className="form-submit-btn"
                disabled={loading}
              >
                {loading ? 'Submitting...' : 'Submit'}
              </button>
            </form>


          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;